import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";
import { useOrganizationStore } from "@/zapi-frontend/stores/organization";

type OrganizationData = {
  organizationName: string;
  customerInstructions: string;
  organizationLogoUrl: string | null;
};

export function useOrganization() {
  const { currentOrganizationId } = useOrganizationStore();

  return useQuery({
    queryKey: ["organization", currentOrganizationId],
    queryFn: async (): Promise<OrganizationData> => {
      const params = currentOrganizationId ? { organizationId: currentOrganizationId } : {};
      const response = await $api.get<{ data: OrganizationData; message: string }>("/organizations/organization", {
        params
      });
      return response.data.data;
    }
  });
}
